import {Message} from 'element-ui'

export const showErrorMsg = (message) => {
  Message({
    message: message,
    type: 'error'
  })
}



// WEBPACK FOOTER //
// ./src/utils/dialog.js